module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid19_980x866.37d0ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid19_980x866.jpg
// module id = wZmO
// module chunks = 0